export default __webpack_public_path__ + "static/media/MARKISH ARUN.3da5dbf3.png";